const EN = {
    "Back to Dashboard": "Back to Dashboard",
    "Dashboard": "Dashboard",
    "OCR": "OCR",
    "Prediction": "Prediction",
    "Total Online Sales": "Total Online Sales",
    "Total Online Visitors": "Total Online Visitors",
    "Total Sales": "Total Sales",
    "Growth": "Growth",
    "to Goal": "to Goal",
    "Yearly": "Yearly",
    "Monthly": "Monthly",
    "File Name": "File Name",
    "Developer attribute requires a valid value to be accessible": "Reference site about Lorem Ipsum, giving information on its origins |  2.6 GB",
    "Earnings": "Earnings",
    "Projects": "Projects",
    "Success Rate": "Success Rate",
    "Etherium rate": "Etherium rate",
    "d":"d",
    "m":"m",
    "y":"y",
    "Visits by Source": "Visits by Source",
    "visitors": "Visitors",
    "Direct Source":"Direct Source",
    "Direct link clicks":"Direct link clicks",
    "Social Networks": "Social Networks",
    "All Social Channels": "All Social Channels",
    "Email Newsletter": "Email Newsletter",
    "Mailchimp Campaigns": "Mailchimp Campaigns",
    "Referrals": "Referrals",
    "Impact Radius visits":"Impact Radius visits",
    "Other": "Other",
    "Many Sources": "Many Sources",
    "Rising Networks": "Rising Networks",
    "Social Network": "Social Network",
    "Warephase stats": "Warephase stats",
    "social visitors": "social visitors",
    "PDF Report": "PDF Report",
    "Stats by Department": "Stats by Department",
    "Actual for April": "Actual for April",
    "Organic Sessions": "Organic Sessions",
    "Domain External Link": "Domain External Link",
    "Visits by Social Networks": "Visits by Social Networks",
    "Dribbble": "Dribbble",
    "Community": "Community",
    "Linked In": "LinkedIn",
    "Social Media": "Social Media",
    "Slack": "Slack",
    "Messanger": "Messanger",
    "YouTube": "YouTube",
    "Video Channel": "Video Channel",
    "Instagram": "Instagram",
    "Top Selling Countries": "Top Selling Countries",
    "World Sales": "World Sales",
    "client name":"Ahmed Ali",
    "client email":"ahhmeadali12@gmail.com",
    "Filter":"Filter",
    "Export":"Export",
    "add_request":"Add Request",
    "add":"Add",
    "name":"Name",
    "number_of_files":"Number Of Files",
    "progress":"Progress",
    "date":"Date",
    "estimated_time":"Estimated Time",
    "actions":"Actions",
    "search":"Search",
    "filter_options":"Filter Options",
    "select_number":"Select Number",
    "reset":"Reset",
    "apply":"Apply",
    "request_completion":"Request Completion",
    "show_original_files":"Show Original Files",
    "show_results":"Show Results",
    "chat":"Chat",
    "edit":"Edit",
    "delete":"Delete",
    "edit_request":"Edit Request",
    "enter_name":"Enter Name",
    "owner":"Owner",
    "example@domain.com":"example@domain.com",
    "simularity":"Simularity",
    "upload_files":"Upload Files",
    "upload_desc":"If you need more info, please check Campaign Guidelines",
    "drop_desc1":"Drop files here or click to upload.",
    "drop_desc2":"Upload up to 10 files",
    "uploaded_files":"Uploaded Files",
    "remove":"Remove",
    "discard":"Discard",
    "please_wait":"Please wait...",
    "submit":"Submit",
    "original_files":"Original Files",
    "original_files_subheader":"Reference site about Lorem Ipsum, giving information on its origins",
    "size":"Size",
    "last_modified":"Last Modified",
    "show":"Show",
    "copy":"Copy",
    "request_list":"Request List",
    "Qiyas":"Qiyas",
    "Send":"Send",
    "Active":"Active",
    "type_message":"Type a message",
    "PM": "PM",
    "Domain External Links": "Domain External Links",
    "submit_msg": "Form has been successfully submitted!",
    "discard_msg": "Are you sure you would like to cancel?",
    "Yes, cancel it": "Yes, cancel it",
    "No, return": "No, return",
    "cancel_msg": "Your form has not been cancelled!.",

}

export default EN